import React from 'react';
import { SocialMediaType } from 'utils/socials';
import { ShareDropdownButton } from '../ShareDropdownButton';
import { ScopedSocialSharingData, ShareDropdown, toSharable } from '../ShareDropdown';

export function ReferralSharing({ referralLink }: ReferralShareDropdownProps) {
  const supportedShareTargets: SocialMediaType[] = ['twitter', 'telegram', 'reddit', 'facebook'];

  const fallback = {
    text: `Check out DuskBreakers. If you Play-to-Mint for a #GribbleEgg, we’ll both get 500 Omnigrow to level up our Eggs! ${referralLink}`,
    link: referralLink,
  };

  const data: ScopedSocialSharingData = {
    twitter: {
      text: `Check out @DuskBreakers. If you Play-to-Mint for a #GribbleEgg, we’ll both get 500 Omnigrow to level up our Eggs! ${referralLink}`,
      link: referralLink,
    },
    telegram: {
      text: `Check out DuskBreakers. If you Play-to-Mint for a #GribbleEgg, we’ll both get 500 Omnigrow to level up our Eggs!`,
      link: referralLink,
    },
    fallback,
  };

  return (
    <ShareDropdownButton data={fallback}>
      <ShareDropdown name="Share" sections={[toSharable(supportedShareTargets, data)]} />
    </ShareDropdownButton>
  );
}

export type ReferralShareDropdownProps = {
  referralLink: URL;
};
